module.exports = "<p>\n  Hello,\n  dashboard works!\n</p>\n"